import Color from 'color'

export const palette = {
    white: '#FAFAFA',
    red: '#D33F3F',
    green: '#51BA68',
    black: '#717171',
    orange: '#F9782C',
    darkFont: '#717171',
    darkFontBG: '#FAFAFA',
    lightFont: '#FAFAFA',
    lightFontBG: '#161616',
    pink: '#D14F67',
    purple: '#7A78B9',
    blue: '#3F9AAF',
    teal: '#3FCCAD'
}

export const flexUtils = {
  FlexRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  FlexColumn: {
    display: 'flex',
    flexDirection: 'column'
  },
  FlexCenter: {
    justifyContent: 'center',
    alignItems: 'center'
  }
}

export const formStyle = {
    FlexRow: {
      display: 'flex',
      flexDirection: 'row'
    },
    FlexColumn: {
      display: 'flex',
      flexDirection: 'column'
    },
    FlexCenter: {
      justifyContent: 'center',
      alignItems: 'center'
    },
    Container: {
      composes: ['$FlexColumn'],
      justifyContent: 'space-between',
      //position: 'absolute',
      top: '0', bottom: '0', left: '0', right: '0'
    },
    Section: {
      textAlign: 'center'
    },
    Header: {
      composes: ['$FlexColumn', '$Section'],
      justifyContent: 'space-between',
      alignItems: 'center',
      fontSize: '1.2rem',
      padding: '0 0 1rem 0',
      color: palette.white
    },
    HeaderMobile: {
      extend: 'Header',
      padding:  '0'
    },
    Body: {
      composes: ['$FlexColumn', '$Section', '$FlexCenter'],
      padding: '0rem 0rem 0rem 0rem',
      flex: '1',
      '& input': {
        '&:-webkit-autofill':{
          '-webkit-text-fill-color': palette.white,
          '-webkit-box-shadow': '0 0 0 1000px inset',
          '-webkit-transition-delay': '9999s'
        },
        // background: palette.white,
        background: 'transparent',
        borderWidth: '0',
        width: '85%',
        color: palette.white,
        boxSizing: 'border-box',
        fontSize: '1.3rem',
        fontWeight: '600',
        padding: '.1rem .4rem',
        margin: '.7rem 0rem 1.3rem 0rem',
        borderBottom: `1px solid ${palette.white}`,
        transition: 'all .5s',
        '&::placeholder': {
          transition: 'all .5s',
          color: palette.white
        },
        '&:focus': {
          background: 'transparent',
          outline: 'none',
          borderBottom: `1px solid ${palette.blue}`,
          '&::placeholder': {
            color: palette.blue
          }
        }
      }
    },
    BodyMobile: {
      extend: 'Body'
    },
    Footer: {
      composes: ['$FlexColumn', '$Section', '$FlexCenter'],
      padding: '0rem 1rem 1rem 1rem'
    },
    NextButton: {
      display: 'inline-block',
      margin: '1rem 1rem 2rem 1rem',
      width: '90%',
      height: '2.8rem',
      lineHeight: '2.8rem',
      background: palette.blue,
      color: palette.lightFont,
      fontSize: '1.3rem',
      fontWeight: '600',
      border: 'none',
      borderRadius: '3px',
      transition: 'all .5s',
      boxShadow: `1px 1px 3px 1px ${Color(palette.black).darken(0.5)}`,
      textDecoration: 'none',
      '&:hover': {
        background: palette.purple,
        cursor: 'pointer'
      },
      '&:focus': {
        outline: 'none'
      },
      '&:active': {
        background: 'red'
      }
    },
    Disabled: {
      composes: ['$NextButton'],
      background: `${Color(palette.blue).lighten(0.5)}`,
      '&:hover': {
        background: `${Color(palette.blue).lighten(0.5)}`,
        cursor: 'pointer'
      }
    },
    WrongMenuText: {
      color: `${Color(palette.darkFont).darken(0)}`,
      '& a': {
        textDecoration: 'none',
        color: palette.orange,
        transition: 'all .3s',
        '&:hover': {
          color: `${Color(palette.orange).lighten(0.2)}`
        }
      }
    },
    ErrorText: {
      display: 'inline-block',
      marginTop: '.5rem',
      fontWeight: '600',
      height: '1rem',
      lineHeight: '1rem',
      color: palette.orange
    }
  }


// WEBPACK FOOTER //
// ./src/js/Theme/Theme.js